<div class="custom-form-field">
  <div class="header">
    <p class="label">
      {{ props.label }}

      @if (props.required) {
        *
      }
    </p>

    <!-- <mat-slide-toggle
      [checked]="isDraft$ | async"
      (toggleChange)="toggleIsDraft()"
      color="primary"
      [disabled]="$any(props)?.disableDraftToggle || props.disabled"
      ><strong>Draft</strong></mat-slide-toggle
    > -->
  </div>

  @for (option of fieldOptions$ | async; track $index) {
    <div class="option">
      @if ($any(props).multiple) {
        <mat-checkbox
          [disabled]="props.disabled || !(isDraft$ | async)"
          (change)="onOptionClicked(option.value)"
          [checked]="getOptionValueChecked(option.value) | async">
          <p>{{ option.label }}</p></mat-checkbox
        >
      } @else {
        <mat-radio-button
          [disabled]="props.disabled || !(isDraft$ | async)"
          (change)="onOptionClicked(option.value)"
          [checked]="getOptionValueChecked(option.value) | async">
          <p>{{ option.label }}</p></mat-radio-button
        >
      }
      @if (optionNeedsCustomPrice(option) | async) {
        <input
          matInput
          type="number"
          placeholder="Price"
          class="custom-price-input"
          [ngModel]="getCustomPrice(option.value) | async"
          (ngModelChange)="onCustomPriceChanged(option.value, $event)" />
      }
    </div>
  }
</div>
